import script from "./batchOrderPlatformnum.vue?vue&type=script&setup=true&lang=js"
export * from "./batchOrderPlatformnum.vue?vue&type=script&setup=true&lang=js"

import "./batchOrderPlatformnum.vue?vue&type=style&index=0&id=7969ef02&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7969ef02"]])

export default __exports__